/* eslint-disable */

import { Router } from "vue-router"

export function trim(text: string) {
    console.log(typeof text, text)
    return text.toString().replace(/(^\s*)|(\s*$)/g, "")
}

export const formatTime = (date: Date) => {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

    return (
        [year, month, day].map(formatNumber).join('-') +
        ' ' +
        [hour, minute, second].map(formatNumber).join(':')
    )
}

const formatNumber = (n: number) => {
    const s = n.toString()
    return s[1] ? s : '0' + s
}

export const formatUnix = (ts: number): string => {
    return formatTime(new Date(ts * 1000))
}


/**
 * 监听页面高度变化
 */
export function observeHeight(page: any, callback?: (height: number) => void) {
    if (!page) {
        return
    }
    let height = document.body.clientHeight;
    const storeHeight = page.$store.state.height
    console.log({ height, storeHeight })
    if (storeHeight < height) {
        page.$store.commit('setHeight', height)
    } else if (storeHeight > height) {
        height = storeHeight
    }
    page.height = height + "px";
    if (callback) {
        callback(height)
    }
    window.addEventListener('resize', function (ev) {
        const tmp = window.innerHeight
        if (tmp > height) {
            page.height = tmp + "px"
            height = tmp
            page.$store.commit('setHeight', tmp)
            if (callback) {
                callback(tmp)
            }
        }
    }, false)
}

/**
 * 搜索地址栏中的参数
 * @param {*} name key 名字
 * @returns 
 */
const getTextParam = (url: string, name: string): string => {
   if (/\?/.test(url)) { // 判断是否有参数
        const urlStr = url.split("?")[1]
        const urlArr = urlStr.split("&")
        for (let i = 0; i < urlArr.length; i++) {
            const urlItem = urlArr[i]
            const item = urlItem.split('=')
            if (item[0] == name) {
                return item[1]
            }
        }
    }
    return ''
}
/**
 * 搜索地址栏中的参数, 包括 search 和 hash, 优先搜索 search 然后搜索 hash
 * @param name key 名字
 * @returns 地址栏中对应的值, 没有搜索到则返回空字符串
 */
export const getUrlParam = (name: string): string => {
    const tailValue = getTextParam(window.location.hash, name)
    if( tailValue) {
        return tailValue
    }
    const value = getTextParam(window.location.search, name)
    if(value) {
        return value
    }
    return getTextParam(window.location.hash, name)
}

/**
 * 替换 text 中的所有字符串
 * @param {*} text 
 * @param {*} oldStr 
 * @param {*} newStr 
 * @returns 
 */
export function replaceAll(text: string, oldStr: string, newStr: string): string {
    if (!text) {
        return text
    }
    return text.replace(new RegExp(oldStr, "gm"), newStr)
}


export function replaceAlign(text: string): string {
    if (!text) {
        return text
    }
    let content = replaceAll(text, '<p>', '<p style="text-align:left;">');
    content = replaceAll(content, '<p style="text-align:right">', '<p style="text-align:center">')
    content = replaceAll(content, 'float:right', '')
    return content
}


export const safeParseInt = (numberText: string, def: number = 1): number => {
    try {
        const value = parseInt(numberText)
        return value
    } catch {

    }
    return def
}

export const getParam = (): UrlParam => {
    const param = {
        id: 0, lid: 0,
    }
    const lidStr = getUrlParam('lid')
    if (lidStr) {
        param.lid = safeParseInt(lidStr)
    }
    const idStr = getUrlParam('id')
    if (idStr) {
        param.id = safeParseInt(idStr)
    }
    return param
}

export const safeRouter = (router: Router, path: string, params: {}) => {
    // console.log({path, params, routers: router.getRoutes()})
    // console.log(router.hasRoute(path), router.hasRoute('/home'))
   try {
    router.push({
        name: path,
        params: params,
        query: params,
    })
   } catch(e) {
    console.log({e})
   }
    // console.log(router)
    // console.log(router.hasRoute(path), router.hasRoute('/home'))
}